/**
 * The active-layer ids after switching basemap: the outgoing basemap and its overlay
 * removed, the incoming basemap and its overlay in front, everything else preserved.
 *
 * A basemap can carry a companion overlay via `overlayLayerId` — hybrid (891) carries
 * topo lines (876). That overlay is a normal data layer, not itself layerNodeId 5, so
 * dropping the outgoing basemap by layerNodeId alone leaves its overlay behind. That is
 * how topo lines kept drawing over satellite: the 3D basemap toggle filtered only on
 * layerNodeId, and because userSettings is shared with 2D and persisted server-side, the
 * stale overlay followed the user into the 2D map too.
 *
 * `replaceAllBasemaps` mirrors the caller's two cases: switching to imagery clears every
 * basemap entry, while switching to a topo layer only replaces the active one.
 *
 * Returns null when the incoming basemap is not in the catalog, meaning "make no change".
 */
export function nextActiveLayerIds({ activeArr, layersDictionary, newLayerId, replaceAllBasemaps }) {
  const dict = layersDictionary || {}
  const current = activeArr || []

  const activeBM = current.find(id => dict[id]?.layerNodeId === 5)
  const outgoingOverlay = dict[activeBM]?.overlayLayerId ?? null

  const kept = replaceAllBasemaps
    ? current.filter(id => (!dict[id] || dict[id].layerNodeId !== 5) && id !== outgoingOverlay)
    : current.filter(id => id !== activeBM && id !== outgoingOverlay)

  const newBM = dict[newLayerId]
  if (!newBM) return null

  const newOverlay = newBM.overlayLayerId ?? null
  const newBase = newOverlay ? [newLayerId, newOverlay] : [newLayerId]
  return newBase.concat(kept.filter(id => id !== newLayerId && id !== newOverlay))
}
